import { Component } from '@angular/core';
import { ComponentUrl, NavigationService, PageTitle, UrlParam } from 'services/navigation.service';
import { NotificationService } from 'services/notification.service';

@ComponentUrl('notification')
@Component({ template: '' })
export class NavigateToNotificationComponent {

	@PageTitle() get pageTitle() { return ''; }
	@UrlParam set notificationId(id: string | undefined) {
		if (!id) return;
		this.notificationService.getNotification(id).then(notification => {
			if (!notification || !this.notificationService.navigateToNotificationSource(notification))
				this.navigationService.closeView(this); // If no notification, or not able to navigate to it, just default to standard Gorm Landing Page
		});
	}

	constructor(private readonly notificationService: NotificationService, private navigationService: NavigationService) { }
}
